export type Testimonial = {
  quote: string
  name: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Nunca pensé que un eBook pudiera tocarme tan profundo. Después de leer «Me Elijo» empecé a poner límites por primera vez en mi vida. Mi familia notó el cambio en menos de dos semanas. Esto no es solo un libro: es un antes y un después.',
    name: 'Valentina M.',
    location: 'Colombia',
  },
  {
    quote:
      'Llevaba años sintiéndome agotada y sin saber por qué. Con el Reto de 30 Días entendí que me había abandonado completamente. Hoy me miro al espejo con amor, algo que creía imposible. Gracias de corazón.',
    name: 'Daniela R.',
    location: 'México',
  },
  {
    quote:
      'El Diario de Autoconfianza me cambió la vida. Por primera vez pude ver mis patrones con claridad. Dejé de buscar aprobación y empecé a confiar en mí misma. Vale cada centavo y mucho más.',
    name: 'Camila T.',
    location: 'Argentina',
  },
]
